module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        street1: {
            type: 'string'
        },
        street2: {
            type: 'string'
        },
        city: {
            type: 'string'
        },
        district: {
            type: 'string'
        },
        districtDesc: {
            type: ['string', 'null']
        },
        region: {
            type: 'string'
        },
        regionDesc: {
            type: ['string', 'null']
        },
        postalCode: {
            type: 'string'
        },
        countryCode: {
            type: 'string'
        },
        countryCodeDesc: {
            type: ['string', 'null']
        },
        internationalAddresses: {
            oneOf: [
                {
                    type: 'array',
                    items: {
                        type: 'object'
                    }
                },
                {
                    type: 'null'
                }
            ]
        }
    }
};